import {Loadable} from "../../library-js/utils";
import useCreateLoadable from "../useCreateLoadable";

export default function useLoadable(load, dependencies){
	return useCreateLoadable(
		() => (load instanceof Function) && new Loadable(load),
		dependencies,
	);
}
